import type {DesignMeta, GraphicMeta, GraphicsMetaMapType} from '@Components/social-media/publish-params.types';
import type {DesignSelection, SocialPlatform} from '@Components/social-media/social-media.types';
import type {SocialMediaAccountId} from '@Components/social-media/post.vo';

const DESIGN_GALLERY_BOTTOM_OFFSET = 250;

export const getGraphicMeta = async ({posterHashedId, pageHashedId}: DesignSelection): Promise<GraphicMeta> => {
  const data = (await window.PMW.writeLocal('socialmedia/getDesignMeta', {
    posterId: posterHashedId,
    pageId: pageHashedId,
  })) as DesignMeta;

  return {graphicURL: data.previewUrl, isVideo: data.isVideo, name: data.designName} as GraphicMeta;
};

export const getFilteredDesigns = (designs: DesignSelection[], max: number): DesignSelection[] => {
  const sanitizedArray = designs.filter((design) => design.posterHashedId && design.pageHashedId);
  if (sanitizedArray.length > max) {
    sanitizedArray.splice(max);
  }

  return sanitizedArray;
};

export const isSingleDesignSelected = (designs: DesignSelection[]): boolean => {
  return designs.length === 1;
};

export const getKeyForPublishParams = (accountId: SocialMediaAccountId): string => {
  return `publish-params-${accountId}`;
};

export const getDesignGalleryHeightForSelectDesignStep = (): string => {
  return `${window.innerHeight - DESIGN_GALLERY_BOTTOM_OFFSET}px`;
};

export const getSanitizedEmphasizedPlatform = (emphasizedPlatform: SocialPlatform | undefined): SocialPlatform | undefined => {
  return emphasizedPlatform ?? undefined;
};

export const buildGraphicsMetaMap = (previewUrls: string[], designsIsVideo: boolean[], designNames: string[], designSelectionInformation: DesignSelection[] = []): GraphicsMetaMapType => {
  const graphicsMetaMap: GraphicsMetaMapType = {};

  for (let i = 0; i < designSelectionInformation.length; i++) {
    const {posterHashedId, pageHashedId} = designSelectionInformation[i];

    graphicsMetaMap[posterHashedId] ??= {};
    graphicsMetaMap[posterHashedId][pageHashedId] = {
      isVideo: designsIsVideo[i],
      graphicURL: previewUrls[i],
      name: designNames[i],
      order: i,
    };
  }

  return graphicsMetaMap;
};

export const getWizardURLForEmphasizedPlatform = (platform: SocialPlatform, idTemplate?: string): string => {
  const getParamKey = 'emphasizedPlatform';

  if (idTemplate) {
    return window.PMW.util.site_url(`socialmedia/post/template/${idTemplate}?${getParamKey}=${platform}`);
  }

  return window.PMW.util.site_url(`socialmedia/post?${getParamKey}=${platform}`);
};
